export default "<app-processed-batch-payments-list></app-processed-batch-payments-list>"